var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editing
    ? _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.number,
            expression: "number",
            modifiers: { number: true }
          }
        ],
        ref: "input",
        attrs: { type: "text" },
        domProps: { value: _vm.number },
        on: {
          blur: [
            function($event) {
              _vm.editing = false
            },
            function($event) {
              return _vm.$forceUpdate()
            }
          ],
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            _vm.editing = false
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.number = _vm._n($event.target.value)
          }
        }
      })
    : _c(
        "span",
        {
          on: {
            click: function($event) {
              _vm.editing = true
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.value) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }